import * as React from "react";
import { UpdatedActiveState } from ".";

interface Props {
  articles: UpdatedActiveState[];
}

const UpdatedActiveArticlesList = ({ articles }: Props) => {
  return (
    <div>
      {!articles.length && <p>Inga artiklar med ny aktiv status hittades.</p>}
      {articles.length > 0 && (
        <table className="table-small dataTable dtr-inline">
          <thead>
            <tr>
              <td>Artikel</td>
              <td>Aktiv</td>
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => (
              <tr key={article.articleNo}>
                <td>{article.name}</td>
                <td>{article.active ? "Ja" : "Nej"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UpdatedActiveArticlesList;
